import React, { useState } from 'react'
import { Link } from 'react-router';
import style from "./navBar.module.css"
import { IoSearch } from "react-icons/io5";
import { HiMenu, HiX } from "react-icons/hi"; // Nouveaux imports pour le menu mobile

const NavBar = ({navBarInfo}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  console.log("Le miniscule ", "Je suis un test".toLowerCase())

  return (
    <nav className={style.main}>
      <div className={style.homeNavBar}>
        <div className={style.homeLogo}> <img src={navBarInfo.icon} alt="" /> <span>{navBarInfo.navLogo}</span></div>
        
        {/* Menu Desktop & Mobile */}
        <div className={`${style.homeSuggestion} ${isMobileMenuOpen ? style.active : ''}`}>
          {navBarInfo.links ? navBarInfo.links.map((text, index) => {
            const currentLink =text.toLowerCase()
            console.log("Quest ce qui se passe ", currentLink)
            return <Link to={currentLink} key={index} className={style.links}> {text} </Link>
          }) : (
            <div className={style.links}>Nav links</div>
          )}
          <div className={style.links}><IoSearch /></div>
        </div>

        {/* Bouton Hamburger pour Mobile */}
        <div className={style.hamburger} onClick={toggleMenu}>
          {isMobileMenuOpen ? <HiX /> : <HiMenu />}
        </div>
      </div>
    </nav>
  )
}

export default NavBar